// @flow
export const promisedCanvasToBlob = (canvas: HTMLCanvasElement, type: string = 'image/jpeg'): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => resolve(blob), type)
  })
}
